import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FileUploadDetailComponent } from '../file-upload-detail/file-upload-detail.component';
import { AddFileUploadComponent } from '../add-file-upload/add-file-upload.component';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
  imports: [
    CommonModule,
    RouterModule,
    FileUploadDetailComponent,
    AddFileUploadComponent,
  ],
})
export class FileUploadComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
